import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import appConfig from '@jobmatchme/library-utils/es/appConfig';
var ENTRY_SURFACE = 'jobs_web';
var ENTRY_PATH_PATTERN = /^\/(?:de|at|pl|en)\/jobs\/(?:service-gastro|fahrer|logistik|disponenten|all)\/suche(?:\/.*)?$/;
var readAdsConsent = function readAdsConsent() {
  var _Cookiebot;
  var consent = (_Cookiebot = window.Cookiebot) === null || _Cookiebot === void 0 ? void 0 : _Cookiebot.consent;
  if (!consent) {
    return undefined;
  }
  if (typeof consent.marketing === 'boolean') {
    return consent.marketing;
  }
  return undefined;
};
export var shouldCreateEntry = function shouldCreateEntry() {
  var pathPattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ENTRY_PATH_PATTERN;
  var pathname = window.location.pathname;
  if (!pathPattern.test(pathname)) {
    return false;
  }
  return true;
};
export var createEntry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2,
      _ref2$endpoint,
      endpoint,
      _ref2$surface,
      surface,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$endpoint = _ref2.endpoint, endpoint = _ref2$endpoint === void 0 ? "".concat(appConfig.routes.comApi, "/tracking/entries/bootstrap") : _ref2$endpoint, _ref2$surface = _ref2.surface, surface = _ref2$surface === void 0 ? ENTRY_SURFACE : _ref2$surface;
            _context.prev = 1;
            if (shouldCreateEntry()) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return fetch(endpoint, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                surface: surface,
                context: {
                  href: window.location.href,
                  pathname: window.location.pathname,
                  search: window.location.search,
                  referrer: document.referrer || undefined
                },
                adsConsent: readAdsConsent()
              })
            });
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error('entry tracking failed', _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function createEntry() {
    return _ref.apply(this, arguments);
  };
}();
export var bootstrapEntryTracking = function bootstrapEntryTracking() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createEntry(options);
};